import React from 'react'
import "../../Website.css";
export default function BaseLayouts(props) {
    return (
        <>
            { props.children }
        </>
    )
}
